
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { IExtraFieldInfo } from 'app/interfaces/IExtraFieldInfo';
import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { BaseSortTransformation } from './basesorttransformation';
import { BooleanDataFlowType } from './dataflow-datatype';
import { DataFlowExpression } from './dataflowexpression';

@Metamodel.model({
    name: 'sort',
    display: [stringResources.DataFlowSortTransformationLabel, stringResources.DataFlowSortTransformationsLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class SortTransformation extends BaseSortTransformation {
    public static readonly MODEL: IModel;

    public inspectDetailsOutputFields: IExtraFieldInfo[] = [
        {
            name: () => stringResources.TransformationInspect_Column_Ordered,
            icon: this._isAscending.bind(this)
        },
        {
            name: () => stringResources.DataFlowNullsFirstLabel,
            icon: this._isNullFirst.bind(this)
        }
    ];

    public partitionLevel: DataFlowExpression = this.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');

    protected getGeneratedDescription(): string {
        return this._getGeneratedDescriptionInteral(stringResources.SortDescription, stringResources.SortNoExpressionDescription);
    }

    private _isNullFirst(column: DataFlowColumn): string {
        const sortExpression = this.sortExpressions.find((e) => e.dataFlowExpression.expression === column.name);
        return sortExpression && sortExpression.nullsFirst ? 'svg-i-20x20-checkmark' : '';
    }
}
